import { View } from "@-/com.npmjs.react-native";
import type { MorphemeHrefObject } from "@-/dev.improve.haniverse.lib.morpheme.href.entities";
import { MorphemeRouteBody } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels.route-body";
import { MorphemePanelsLayout } from "#morpheme-panels-layout";
import { MorphemeFlashcardPanelBackContext } from "#morpheme-card-panel-back-context";
import type { ReactNode } from "react";

/**
 * The `(panels)` layout shared by every card route family (Browse, Search, Decks, Collections,
 * Explore): the morpheme contexts and header glyph above the routed `MorphemeFlashcardPanel`, so a
 * card opened from any tab renders the same Learn / Details page.
 */
export function MorphemeFlashcardPanelsLayout({
  children,
  headerExpansionContent,
  morpheme,
  morphemeHrefObject,
  onBack,
}: {
  children: ReactNode;
  headerExpansionContent?: ReactNode;
  morpheme: string | string[];
  morphemeHrefObject: MorphemeHrefObject;
  onBack?: () => void;
}) {
  return (
    <MorphemeRouteBody>
      <View className="min-h-0 flex-1 bg-background">
        {headerExpansionContent}
        <MorphemeFlashcardPanelBackContext value={onBack}>
          <MorphemePanelsLayout morpheme={morpheme} morphemeHrefObject={morphemeHrefObject}>
            {children}
          </MorphemePanelsLayout>
        </MorphemeFlashcardPanelBackContext>
      </View>
    </MorphemeRouteBody>
  );
}
